import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const mcpEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('mcpEntitlementsState', undefined);

export const mcpEntitlementsStateActions = mcpEntitlementsStateSlice.actions;
export const mcpEntitlementsStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    EntitlementsFilters
> = state => state.accountPage.tabs.mcpEntitlements.state;
